import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Listar from '../../../../components/auth/ouvidoria/adm'


function ListarRequisicoesScreen() {

    return (
        <Fragment>
            <Head titulo="Requisições do Administra Cidadão Cadastradas" />
            <HeaderLogged />
            <Container>
               <Listar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListarRequisicoesScreen;